<template>
  <section id="form-disambiguation">
    <!-- At the moment, this page simply creates a draft form using parameters from the URL and then redirects to the draft -->
    <b-loading :is-full-page="false" :active="true" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import { AssetService } from "@/services/asset.service.js";
import { FormService } from "@/services/form.service.js";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { AssetClass } from "@/helpers/asset-class-options.js";
// import _ from "lodash";

export default {
  name: "form-disambiguation",
  async mounted() {
    if (process.env.ENVIRONMENT == "local") {
      this.$buefy.toast.open("DEV NOTE: Hit form-disambiguation component.");
    }

    // // Determine form type and check if valid asset type
    // let formType = "";
    // if (this.$route.query.asset_id) {
    //   const responses = await Promise.all([
    //     AssetService.show(this.$route.query.asset_id, { includes: "code" })
    //       .then(response => JsonDenormalizer.denormalize(response)),
    //     FormService.listFormTypeAssetCodes(),
    //   ]);
    //   const asset = responses[0];
    //   const assetCode = asset.code ? asset.code.code : "";
    //   const assetCodesByFormType = responses[1];
    //   const { HOTSPOT, ...assetCodes } = assetCodesByFormType;
    //   const assetCodesHotspot = { HOTSPOT };
    //   for (const [key, value] of Object.entries(this.$route.query.hotspot ? assetCodesHotspot : assetCodes)) {
    //     if (value.includes(assetCode)) {
    //       formType = key;
    //       break;
    //     }
    //   }
    //   if (!formType) {
    //     this.$buefy.toast.open({
    //       message: "Inspection Form not found for Asset Type",
    //       type: "is-danger",
    //       position: "is-top-right",
    //     });
    //     if (this.$route.query.order_id) {
    //       this.$router.replace({
    //         name: "order-list",
    //         query: { orderId: this.$route.query.order_id }
    //       });
    //     } else {
    //       this.$router.replace({
    //         name: "form-list",
    //       });
    //     }
    //     return;
    //   }
    // }

    let form_type_id = this.$route.query.form_type_id;
    let form_type_code = this.$route.query.form_type_id
      ? null
      : this.$route.query.form_type_code;

    if (form_type_code) {
      // Check if valid form type
      // API will handle
    }

    const data = {
      status: "DRAFT",
      form_type_id: form_type_id || undefined,
      form_type_code: form_type_code || undefined,
      order_id: this.$route.query.order_id,
      order_operation_id: this.$route.query.operation_id || undefined,
      asset_id: this.$route.query.asset_id || undefined
    };

    this.createDraftAndRedirect(data);
  },
  methods: {
    async createDraftAndRedirect(data) {
      try {
        const response = await FormService.store(data).then(response => response.data);
        console.log("success")
        // We deliberately use $router.replace instead of $router.push
        // (since we don't want the back behaviour to return here)
        this.$router.replace({
          name: "form-edit",
          params: { id: response.data.id }
        });
      } catch (err) {
        console.log("error")
        if (this.$route.query.order_id) {
          this.$router.replace({
            name: "order-list",
            query: { orderId: this.$route.query.order_id }
          });
        } else {
          this.$router.replace({
            name: "form-list"
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Forms/disambiguation/index.vue